module.exports = __webpack_public_path__ + "static/media/menu.dd3ee4a5.svg";